

import { createAction } from '@reduxjs/toolkit';

export const addTodo = createAction('todos/AddTodo', (text) => {

  const id = new Date().toString();
  return {
    payload: {
      id,
      text,
    },
  };
});

export const deleteTodo = createAction('todos/DeleteTodo');
export const toggleCompleted = createAction('todos/ToggleCompleted');
export const setStatusFilter = createAction('filters/setStatusFilter');


